import React from "react";
import { useTranslation } from "react-i18next";
import Main from "../../components/Main/Main";
import Blockquote from "../../components/Blockquote/Blockquote";
import Services from "../../components/Services/Services";
import Projects from "../../components/Projects/Projects";
import WebServices from "../../components/WebServices/WebServices";
import SEOHead from "../../components/SEO/SEOHead";
import { organizationJsonLd, websiteJsonLd } from "../../seo/jsonld";

const HomePage = () => {
    const { t } = useTranslation();
    return (
        <main>
            <SEOHead
                title={t("seo.home.title")}
                description={t("seo.home.description")}
                path="/"
                jsonLd={[organizationJsonLd(), websiteJsonLd()]}
            />
            <Main />
            <Blockquote />
            <Services />
            <Projects />
            <WebServices />
        </main>
    );
};

export default HomePage;
